import React, { useState } from 'react';
import './UserAvatar.css';

export function getAvatarUrl(avatarUrl) {
  if (!avatarUrl) return null;
  if (/^https?:\/\//i.test(avatarUrl) || avatarUrl.startsWith('data:')) return avatarUrl;

  const apiBaseUrl = process.env.REACT_APP_API_URL || '/backend';
  if (avatarUrl.startsWith('/backend/')) return avatarUrl;
  return `${apiBaseUrl.replace(/\/$/, '')}/${avatarUrl.replace(/^\/+/, '')}`;
}

function UserAvatar({ user, name, avatarUrl, className = '', alt = '' }) {
  const [hasImageError, setHasImageError] = useState(false);
  const displayName = name || user?.name || '';
  const imageUrl = getAvatarUrl(avatarUrl || user?.avatar_url || user?.profile_image || user?.avatar);
  const showImage = imageUrl && !hasImageError;

  return (
    <span className={`user-avatar ${className}`.trim()}>
      {showImage ? (
        <img src={imageUrl} alt={alt || `عکس پروفایل ${displayName}`} onError={() => setHasImageError(true)} />
      ) : (
        <span aria-hidden="true">{displayName ? displayName.charAt(0) : '؟'}</span>
      )}
    </span>
  );
}

export default UserAvatar;
